var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59467 1.71967C9.88756 1.42678 10.3624 1.42678 10.6553 1.71967L12.9053 3.96967C13.1982 4.26256 13.1982 4.73744 12.9053 5.03033L10.6553 7.28033C10.3624 7.57322 9.88756 7.57322 9.59467 7.28033C9.30178 6.98744 9.30178 6.51256 9.59467 6.21967L10.5643 5.25H9.375C6.71421 5.25 4.5 7.46421 4.5 10.125C4.5 12.7858 6.71421 15 9.375 15C12.0358 15 14.25 12.7858 14.25 10.125C14.25 9.71079 14.5858 9.375 15 9.375C15.4142 9.375 15.75 9.71079 15.75 10.125C15.75 13.6142 12.8642 16.5 9.375 16.5C5.88579 16.5 3 13.6142 3 10.125C3 6.63579 5.88579 3.75 9.375 3.75H10.5643L9.59467 2.78033C9.30178 2.48744 9.30178 2.01256 9.59467 1.71967Z",
    fill: "#0156CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c8ea99c25fa8fdc36d68407c4f471574.svg";
export { ForwardRef as ReactComponent };